import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { RotinasAnaliticasComponent } from './app/pages/rotinas-analiticas/rotinas-analiticas.component';

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));